var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "screen-control-header" }, [
    _c(
      "div",
      {
        staticClass:
          "d-flex justify-space-between screen-control-header__header",
      },
      [
        _c(
          "div",
          { staticClass: "d-flex align-center" },
          [
            _c("kh-text", {
              staticClass:
                "screen-control-header__title screen-control-table-primary-color",
              attrs: { text: _vm.title },
            }),
            _vm._v(" "),
            _c("kh-text", {
              staticClass:
                "screen-control-header__sub-title screen-control-table-variant-color",
              attrs: { text: _vm.subTitle },
            }),
            _vm._v(" "),
            _vm.currentPage && _vm.lastPage
              ? _c("kh-text", {
                  staticClass:
                    "screen-control-header__paging screen-control-table-variant-color",
                  attrs: { text: _vm.pagination },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("kh-text", {
              staticClass:
                "screen-control-header__title screen-control-table-primary-color",
              attrs: { text: _vm.room },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-center mr-4" },
          [
            _c("kh-text", {
              staticClass: "screen-control-planning-table__clock",
              attrs: { text: _vm.formattedDate },
            }),
            _vm._v(" "),
            _vm.isCurrentDay
              ? _c("kh-time-clock", {
                  attrs: {
                    "class-name": " screen-control-planning-table__clock ml-4",
                    "label-format": "HH:mm",
                    interval: _vm.IntervalTime.MINUTE,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }